
<template>
    <!-- 选择合同 -->
        <div>
          
          <el-form
        :model="searchForm"
        ref="searchFormRef"
        label-width="100px"
        label-suffix=":"
     
      >
        <el-row :gutter="24">
        
          <el-col :span="6">
            <el-form-item label="账单分类" prop="tradeType">
              <el-select v-model="searchForm.tradeType" style="width: 100%" placeholder="账单分类">
              <el-option
                v-for="(item, index) in tradeTypeList"
                :key="index"
                :label="item.dictValue"
                :value="item.dictKey"
              ></el-option>
            </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
          <el-form-item label="日期" prop="daterange">
            <el-date-picker
              v-model="searchForm.daterange"
              style="width: 100%;"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
                <el-col span="6">
                  <div style="float:right">
                    <el-button type="primary" @click="searchBtn" size="small"> 搜索 </el-button>
                  <el-button @click="searchClear" size="small"> 清空 </el-button>
          </div>
                 
                </el-col>
              </el-row>
            </el-form>
            <!-- <el-radio-group v-model="radio"> -->
              <avue-crud
              :option="option"
              :table-loading="loading"
              :data="data"
              :page.sync="page"
              ref="crud"
              @on-load="onLoad"
              @current-change="currentChange"
              @size-change="sizeChange"
              @refresh-change="onLoad"
              @selection-change="selectionChange"
            >
            <template slot="menuLeft">
              <div>
                <div style="display: inline;margin-right: 10px;">
                <span>共计 : {{ page.total }} {{ "笔" }}</span>
                </div>
                <div style="display: inline;margin-right: 10px;" v-for="(item,index) in statistics" :key="index">
                <span>{{ item.tradeTypeName }} :{{ item.totalAmount }} {{ "元" }}</span>
                </div>
                
              </div>
      </template>
            </avue-crud>
        
         
            
        </div>
    </template>
    
    <script>
   import {smartcardflowpage,smartcardflowstatistics } from '@/api/nursingHome/nursingCard';
   import { getDictionary } from '@/api/common.js';
    export default {
      props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
      data() {
        return {
       
          radio: '',
          
          option: {
            page: true,
            height:'500',
            align: 'center',
            menu: false,
            addBtn: false,
            editBtn: false,
            delBtn: false,
            border:true,
            column: [
          {
            label: '分类',
            prop: 'tradeType',
            type: 'select',
            dataType: 'number',
            dicUrl: '/api/blade-system/dict/dictionary?code=nursinghome_smart_card_trade_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '账目类型',
            prop: 'accountType',
            type: 'select',
            dataType: 'number',
            dicUrl: '/api/blade-system/dict/dictionary?code=nursinghome_smart_card_account_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
          },
          {
            label: '发生时间',
            prop: 'createTime',
          },
          {
            label: '金额',
            prop: 'amount',
          },
        ],
          },
          searchForm: {
            cardId: '',
            tradeType:'',
            timeStart:'',
            timeEnd:'',
            daterange:[]
          },
          page: {
            pageSize: 10,
            currentPage: 1,
            total: 0,
          },
          statistics:[],
          data:[],
        };
      },
      created() {
       this.searchForm.cardId =this.row.id
       getDictionary('nursinghome_smart_card_trade_type').then((res) => {
        this.tradeTypeList = res.data;
      });
       
      },
      methods: {
       
        searchBtn(){
          this.page.currentPage = 1 
          if(this.searchForm.daterange&&this.searchForm.daterange.length>0){
          this.searchForm.timeStart = this.dayjs(this.searchForm.daterange[0]).format('YYYY-MM-DD 00:00:00')
          this.searchForm.timeEnd =  this.dayjs(this.searchForm.daterange[1]).format('YYYY-MM-DD 23:59:59')
        }else{
          this.searchForm.timeStart = ''
          this.searchForm.timeEnd = ''
          
        }
          this.onLoad()
        },
       
        onLoad() {
        
          this.loading = true;
  
          smartcardflowpage(
            Object.assign(
              {},
              { current: this.page.currentPage, size: this.page.pageSize },
              this.searchForm
            )
          )
            .then(({ data }) => {
              this.data = data.records;
              this.page.total = data.total;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });

            smartcardflowstatistics(
              this.searchForm
            ).then(res=>{
              this.statistics = res.data
            })
      },
       
        //提交
        searchClear() {
          this.tool.clearObject(this.searchForm, 'cardId');
        },
        //获取合同类型
  
        
      },
    };
    </script>
    
    <style scoped>
    .btnArea {
      widows: 100%;
      text-align: center;
      margin-top: 20px;
    }
    ::v-deep .avue-crud .el-form-item {
      display: block;
    }
    .money{
      text-align: right;
    }
    </style>
    